import { ArtifactTheme, SceneItem } from "../../models/client";

export function artifactThemeToSceneItem(
  artifactTheme: ArtifactTheme
): SceneItem {
  return {
    id: artifactTheme.id,
    title: artifactTheme.name,
    slug: artifactTheme.slug,
    color: artifactTheme.color,
    position: artifactTheme.sceneItemConfig.position,
    image: artifactTheme.sceneItemConfig.image,
    offsetPosition: artifactTheme.sceneItemConfig.offsetPosition,
    btnColor: artifactTheme.sceneItemConfig.btnColor,
    size: artifactTheme.sceneItemConfig.size,
  };
}
